// Etapa 6 — Servis: číselníky, štítky a drobné formátovače sdílené napříč obrazovkami.
export const TYP_ZAPISU_LABEL = {
  PROHLIDKA: "Prohlídka",
  SERVIS: "Servis",
  OPRAVA: "Oprava",
  INSTALACE: "Instalace",
  UVEDENI_DO_PROVOZU: "Uvedení do provozu",
  SKOLENI: "Školení",
};
// Hodnoty, které už nejde vybrat, ale staré zápisy je nesou.
const TYP_ZAPISU_STARE = { ZARUCNI_OPRAVA: "Záruční oprava" };
export const typZapisuLabel = (typ) => TYP_ZAPISU_LABEL[typ] || TYP_ZAPISU_STARE[typ] || typ || "";

export const UCTOVANI_LABEL = {
  PLACENY: "Placeno",
  ZARUCNI: "Záruka",
};

export const ZAVAZNOST_LABEL = { NIZKA: "Nízká", STREDNI: "Střední", VYSOKA: "Vysoká" };

export const STAV_ZARIZENI_LABEL = {
  V_PROVOZU: "V provozu",
  MIMO_PROVOZ: "Mimo provoz",
  VYRAZENO: "Vyřazeno",
  // Zařízení rozjeté zakázky — nastavuje ho server při zahájení montáže,
  // do servisu přejde předáním. Ručně se nevybírá.
  MONTAZ: "V montáži",
};

// Stavový chip zápisu — podepsáno má přednost, pak porucha u oprav, jinak dle účtování.
export function zapisChip(z) {
  if (z.stav === "PODEPSANY" || z.stav === "ODESLANY")
    return { label: "Podepsáno", cls: "text-[#17876a] bg-[#eaf6f1]" };
  if (z.typ_zapisu === "OPRAVA" || z.typ_zapisu === "ZARUCNI_OPRAVA")
    return { label: "Porucha", cls: "text-[#8f2419] bg-[#fdeae7]" };
  const map = {
    VE_SMLOUVE: { label: "Ve smlouvě", cls: "text-[#4a5563] bg-[#f2f4f6]" },
    PLACENY: { label: "Placeno", cls: "text-[#c8551a] bg-[#fdf1e8]" },
    ZARUCNI: { label: "Záruka", cls: "text-[#2c6ecb] bg-[#eef4fd]" },
  };
  return map[z.uctovani] || { label: "Rozpracováno", cls: "text-sec bg-inputbg" };
}

export function fmtYmd(d) {
  if (!d) return "—";
  const [y, m, dd] = String(d).split("-");
  return dd ? `${Number(dd)}. ${Number(m)}. ${y}` : d;
}

// "9/2026" pro kompaktní zobrazení termínu prohlídky
export function fmtMonthYear(d) {
  if (!d) return null;
  const [y, m] = String(d).split("-");
  return m ? `${Number(m)}/${y}` : d;
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
}

// přičti minuty k "HH:MM"
export function addMinutes(hhmm, mins) {
  const [h, m] = (hhmm || "00:00").split(":").map(Number);
  let total = (h * 60 + m + mins + 1440 * 3) % 1440;
  const nh = Math.floor(total / 60), nm = total % 60;
  return `${String(nh).padStart(2, "0")}:${String(nm).padStart(2, "0")}`;
}

export function fmtHodiny(h) {
  return (Number(h) || 0).toString().replace(".", ",") + " h";
}
